module.exports = __webpack_public_path__ + "img/icon-arrow-down.b025ef34.svg";